import defaultSettings from '@/settings'

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  tabs: [],
  globalLoading: false
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_TABS(state) {
    state.tabs = JSON.parse(sessionStorage.getItem('tagList'))
  },
  SET_LODING(state) {
    state.globalLoading = !state.globalLoading
  },
  // 添加群组
  pushGroupId(state, { name, id, pathName, dataInfo }) {
    const path = pathName + id

    if (
      !state.tabs.some(item => {
        return item.path === path
      })
    ) {
      state.tabs.push({
        name: name,
        path: path,
        groupId: id,
        dataInfo: dataInfo
      })
    } else {
      for (let i = 0; i < state.tabs.length; i++) {
        if (state.tabs[i].path === path) {
          state.tabs.splice(i, 1, {
            name: name,
            path: path,
            groupId: id
          })
          break
        }
      }
    }
    // if (state.tabs.length > 16) {
    //   state.tabs.splice(0, 1)
    // }
    sessionStorage.setItem('tagList', JSON.stringify(state.tabs))
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
